<template>
  <div id="app">
    <div class="container">
      <b-alert :show="showAlert" :variant="alertStyle">{{alertText}}</b-alert>
      <b-card v-if="!showAlert" header="About DB CSI">
        <b-list-group>
          <b-list-group-item>
            <div>
              <b>What is Database Current State Investigation (DB CSI)?</b>
              <p/>
              DB CSI is a collaborative tool to help customers and AWS to jointly research the key performance metrics of their current databases.  The tool is designed to help make initial estimates about the starting size and shape if the database was lifted to run in AWS.  Of course, the sizing estimate is just a starting point and the elasticity of AWS easily allows customers to fine-tune the sizing decisions at any time.
            </div>
          </b-list-group-item>
          <b-list-group-item>
            <div>
              <b>Does DB CSI look at my database's data?</b>
              <p/>
              No. DB CSI looks at the metadata of your database, but not the data itself.  It is looking at the data dictionary to retrieve performance metrics like database size and IO/CPU/Memory usage.            
            </div>
          </b-list-group-item>
          <b-list-group-item>
            <div>
              <b>Does DB CSI store data about my database?</b>
              <p/>
              No, it does not store your database's data.  It does store some of your database's <b>metadata</b>. DB CSI collects metadata about your database, such as performance metrics about IO/CPU/Memory usage, and stores them in a secured database in the AWS cloud.  This metadata is only viewable by the user who uploaded the data, specific additional users who you explicitly grant access, and by members of the AWS database SA team working with you.  Again, this is metadata, not actual database data, that is being stored.
            </div>
          </b-list-group-item>
          <b-list-group-item>
            <div>
              <b>Why do I need to create an account?</b>
              <p/>
              To use DB CSI, you will upload raw metadata from your database and then the DB CSI backend will process it so that it can be easily viewed and analyzed by you and the AWS database SA team working with you.  You need to create an account so that your data can be secured so that only you and your AWS SA team can see it.  To enforce this security, we require you to have an account created.
            </div>
          </b-list-group-item>
          <b-list-group-item>
            <div>
              <b>What is the architecture of DB CSI?</b>
              <p/>
              DB CSI is a serverless application.  The web application is built with AWS Amplify and the javascript vue.js framework.  It utilizes Amazon Cognito for security.  It leverages Amazon API Gateway and AWS Lambda for dynamic code.  It leverages S3 to store raw metadata.  Refined, processed metrics are stored in a serverless Aurora database.<br/>
              <img src="@/assets/CSI_architecture.png" height="400px"/>
            </div>
          </b-list-group-item>
          <b-list-group-item>
            <div>
              <b>How can I request changes or enhancements to DB CSI, or report any issues?</b>
              <p/>
              <a href="mailto:dbayard@amazon.com">Click here for Suggestions or Feedback for Database CSI</a>
            </div>
          </b-list-group-item>
        </b-list-group>
      </b-card>
    </div>
  </div>
</template>    


<script>
import { API, Storage } from "aws-amplify";
export default {
  name: "app",
  props: ["user"],
  data() {
    return {
      selected: null,
      output_file: null,
      show: true,
      showAlert: false,
      alertText: "",
      alertStyle: "default",
    };
  },
  methods: {
  }
};
</script>

<style>
</style>
